import angular from 'angular';
import TermsPreviewDialogComponent from './terms-preview-dialog-component';


export default angular
  .module('terms-preview-dialog', [])
  .component('termsPreviewDialog', new TermsPreviewDialogComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/terms/components/terms-preview-dialog/terms-preview-dialog-module.js